import { useEffect, useRef } from 'react'

import { EMPTY_OBJECT } from '../constants/common'

/**
 * Used to scroll into the visibility area of the component during the first render,
 * or add a trigger options: {dependency}
 *
 * @example
 *
 * const [open, setOpen] = useState(false)
 *
 * const { ref } = useScrollIntoView({dependency: open, block: 'end'})
 *
 * @param options - scroll options
 */
export function useScrollIntoView({
  behavior = 'smooth',
  block = 'center',
  dependency = null,
} = EMPTY_OBJECT) {
  const ref = useRef(null)

  useEffect(() => {
    ref.current?.scrollIntoView({ behavior, block })
  }, [dependency])

  return { ref }
}
